import Button from "@shared/button";
import i18n from "@utils/i18n";

import style from "./404.styl";

const Page404 = () => {
  return (
    <div className={style.page}>
      <div className={style.background}>404</div>
      <div className={style.foreground}>
        <span className="subtitle dark">{i18n.t("common:notFoundTitle")}</span>
        <span className="body dark">
          {i18n.t("common:notFoundDescription")}
        </span>
        <Button className={style.back} href="/">
          {i18n.t("common:backToHome")}
        </Button>
      </div>
    </div>
  );
};

export default Page404;
